import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface AlternativeAddressFieldsState {
  values: {
    [key: string]: boolean
  }
}
const initialState: AlternativeAddressFieldsState = {
  values: {
    introAddressCity: false,
    introAddressStreet: false,
    customerAddressAbwCity: false,
    customerAddressAbwStreet: false,
    vendorFaf1City: false,
    vendorFaf1Street: false,
    vendorFaf2City: false,
    vendorFaf2Street: false,
    generatorAddressAbwCity: false,
    generatorAddressAbwStreet: false
  }
}

export const alternativeAddressFieldsSlice = createSlice({
  name: 'alternativeAddressFields',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setAltAddressFieldsSlice: (
      state,
      action: PayloadAction<{[key: string]: boolean}>
    ) => {
      state.values = action.payload
    }
  }
})

export const { setAltAddressFieldsSlice } = alternativeAddressFieldsSlice.actions

export default alternativeAddressFieldsSlice.reducer
